(function () {
    'use strict';
    /*
     * Copyright (c) 2020 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('DownloadDataSvc', DownloadDataSvc);

    DownloadDataSvc.$inject = [];

    /*
     * Provides a a service for downloading data as a file from the browser.
     */
    function DownloadDataSvc() {

        this.download = download;

        function download(data, mimeType, filename) {
            var blob = new Blob([data], {
                type: mimeType
            });
            var tmpLink = document.createElement("a");
            var downloadUrl = URL.createObjectURL(blob);

            tmpLink.setAttribute('href', downloadUrl);
            tmpLink.setAttribute('download', filename);
            tmpLink.style.visibility = 'hidden';

            tmpLink.click();

            URL.revokeObjectURL(downloadUrl);
        }
    }
})();